
export const allPro = [
    //3ce
    {
        id: 1,
        name:  "3CE HAZY LIP CLAY - 3ce",
        price: 759.00,
        quantity: 5,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "MakeUp",
        brand: "3ce",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/31.jpg",
        description : "จากทรีซีอี เนื้อเคลย์หลอมละลายไปกับริมฝีปากของคุณ ไม่จับตัวเป็นก้อน มอบสัมผัสแมทละเอียดอ่อนนุ่มสบายไม่แห้งตึง ติดทนยาวนาน"
    },

    {
        id: 2,
        name: "3CE MULTI EYE COLOR PALETTE - 3ce",
        price: 739.00,
        quantity: 3,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "MakeUp",
        brand: "3ce",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/32.jpg",
        description : "พาเลทอายแชโดว์ เกลี่ยง่ายและติดทนนาน มีให้เลือกหลากหลายโทน ใช้สะดวก เหมาะสำหรับหลายลุค คุ้มค่ากับราคา"
    },

    {
        id: 3,
        name: "3CE NEW TAKE EYESHADOW - 3ce",
        price: 690.00,
        quantity: 4,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "MakeUp",
        brand: "3ce",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/33.jpg",
        description : "ทรีซีอี นิวเทค อายแชโดว์ เครื่องสำอาง พาเลท พาเลทตา พาเลตต์แต่งตา พาเลตต์อายแชโดว์"
    },

    {
        id: 4,
        name: "[PURE PAIRING] 3CE NEW TAKE EYESHADOW PALETTE - 3ce",
        price: 1119.00,
        quantity: 6,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "MakeUp",
        brand: "3ce",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/34.jpg",
        description : "ทรีซีอี นิวเทค อายแชโดว์ พาเลท เครื่องสำอาง พาเลทตา พาเลตต์แต่งตา"
    },

    {
        id: 5,
        name: "3CE VELVET LIQUID BLUSHER - 3ce",
        price: 959.00,
        quantity: 8,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "MakeUp",
        brand: "3ce",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/35.jpg",
        description : "ทรีซีอี เวลเวท ลิควิท บลัชเชอร์ เครื่องสำอาง บลัชออน ปัดแก้ม บลัชออนเนื้อแมท"
    },
    
    //4U2
    {
        id: 6,
        name:  "4U2 LIP OIL- 4U2",
        price: 159.00,
        quantity: 5,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "MakeUp",
        brand: "4U2",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/41.jpg",
        description : "ลิปออยล์บำรุงริมฝีปาก ช่วยให้ความชุ่มชื้นด้วยส่วนผสมของน้ำมันบำรุงจากธรรมชาติ พร้อมเปลี่ยนสีตามค่า pH ของผิว มอบริมฝีปากเนียนนุ่ม อมชมพู ดูสุขภาพดี"
    },

    {
        id: 7,
        name: "4U2 MATTE BALM LIPSTICK - 4U2",
        price: 199.00,
        quantity: 3,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "MakeUp",
        brand: "4U2",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/42.jpg",
        description :"ลิปบาล์มแมทเนื้อบาล์ม นุ่มฟู-สีชัดเกลี่ยง่าย-สเตนสีติดทน"
    },

    {
        id: 8,
        name: "4U2 PLUMPING GLOSS - 4U2",
        price: 199.00,
        quantity: 4,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "MakeUp",
        brand: "4U2",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/43.jpg",
        description : "เสกปากฉ่ำ เงา วาวขั้นสุดฟีลน้ำตาลเคลือบโดนัท! เติมความชุ่มชื้น ปากอิ่มฟูตลอด 24 ชม"
    },

    {
        id: 9,
        name: "4U2 BLENDING LIP LINER - 4U2",
        price: 179.00,
        quantity: 6,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "MakeUp",
        brand: "4U2",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/44.jpg",
        description : "น้องลิปไลน์เนอร์ ดินสอเขียน&เบลนด์ขอบปาก แบบ OVER LIP เนื้อซอฟท์แมท นุ่มมากก สีละมุน"
    },

    {
        id: 10,
        name: "4U2 DEAR ME LIQUID BLUSH - 4U2",
        price: 179.00,
        quantity: 8,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "MakeUp",
        brand: "4U2",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/45.jpg",
        description : "เนื้อลิควิด บางเบาสบายผิว แตะนิดเดียวก็ให้สีสวยชัด เกลี่ยง่าย ได้ลุคที่ดูเป็นธรรมชาติ แก้มฉ่ำเงาดิวอี้ แต่ติดทน"
    },

    //espoir
    {
        id: 11,
        name:  "ESPOIR PRO TAILOR BE VELVET CUSHION SPF34 PA++ 13g - espoir",
        price: 834.00,
        quantity: 5,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "MakeUp",
        brand: "espoir",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/es1.jpg",
        description : "คุชชั่น คุชชั่นวีแกน เนื้อกำมะหยี่ ปกปิด คุชชั่นเนื้อแมตต์เนียนนุ่มดุจกำมะหยี่ ให้การปกปิดดีเยี่ยมเพื่อผิวสวยเรียบเนียนดูมีมิติเป็นธรรมชาติ "
    },

    {
        id: 12,
        name: "ESPOIR COUTURE LIP TINT GLAZE 5.5g - espoir",
        price: 649.00,
        quantity: 3,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "MakeUp",
        brand: "espoir",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/es2.jpg",
        description : "เคลือบแวววาวราว ริมฝีปากดูอวบอิ่ม สดใส พร้อมเอฟเฟกต์ 3D เนื้อฟิล์มไซรัปที่หนาขึ้น มอบความเงางามเป็นประกายแวววาว"
    },

    {
        id: 13,
        name: "ESPOIR TONE PAIRING CHEEK 9.6g  - espoir",
        price: 768.00,
        quantity: 4,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "MakeUp",
        brand: "espoir",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/es3.jpg",
        description : "ให้สัมผัสบางเบาที่ดูโปร่งใส เปล่งประกายชัดเจน การจับคู่กันระหว่างเนื้อ: Sheer Jelly & Blurring Matte "
    },

    {
        id: 14,
        name: "ESPOIR Real Eye Palette All New 7.5g 2023 - espoir",
        price: 660.00,
        quantity: 6,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "MakeUp",
        brand: "espoir",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/es4.jpg",
        description : "แต่งหน้าครบจบในพาเลทเดียว ช่วยมอบลุคเมคอัพแบบสมบูรณ์ ด้วยการผสมผสานสีที่เข้ากับสีผิว สามารถ mix match ได้กับทุกๆ สี สามารถสร้างลุคสวยๆได้หลายลุคในพาเลทเดียว"
    },

    {
        id: 15,
        name: "ESPOIR WATER SPLASH SUN CREAM CICA SPF50+ PA++++ 60ml - espoir",
        price: 615.00,
        quantity: 8,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "MakeUp",
        brand: "espoir",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/es5.jpg",
        description : "เอสปัวร์ ครีมกันแดด เซราไมด์ สูตรปรับสีผิวพร้อมเอฟเฟกต์เมคอัพเบสช่วยให้ผิวกระจ่างใสและปรับสีผิวให้สม่ำเสมอก่อนแต่งหน้า"
    },

    //Etude
    {
        id: 16,
        name:  "Fixing Tint- etude",
        price: 344.00,
        quantity: 5,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "MakeUp",
        brand: "etude",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/ed1.jpg",
        description : "High moisture matte texture, light and comfortable feeling like my lipsCompleted human body application test to prevent smearing of mask Fixing the lips moist as if they were stained"
    },

    {
        id: 17,
        name: "Double Lasting Serum Skin Foundation - etude",
        price: 712.00,
        quantity: 3,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "MakeUp",
        brand: "etude",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/ed2.jpg",
        description : "รองพื้นบำรุงที่มอบความกระจ่างใสตลอด 24 ชั่วโมง ทำให้ผิวดูสวยสุขภาพดี เบาสบายแนบสนิทไปกับผิว ผิวสวยตลอดวัน ผสานประสิทธิภาพในการบำรุงผิวและการแต่งหน้าเข้าด้วยกัน "
    },

    {
        id: 18,
        name: "PANG PANG HAIR SHADOW - etude",
        price: 250.00,
        quantity: 4,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "MakeUp",
        brand: "etude",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/ed3.jpg",
        description :"ETUDE Pang Pang Hair Shadow (3.5g) อีทูดี้ ผลิตภัณฑ์ตกแต่งผม ผลิตภัณฑ์ตกแต่งผมที่มาในรูปแบบพัฟคูชั่น พกพาสะดวก เพิ่มความมั่นใจได้ง่ายๆทุกทีทุกเวลา กันน้ำและเหงือ ล้างออกง่ายด้วยสบู่หรือยาสระผม"
    },

    {
        id: 19,
        name: "ETUDE [Playlist] Glow Fixing Tint- etude",
        price: 392.00,
        quantity: 6,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "MakeUp",
        brand: "etude",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/ed4.jpg",
        description : "ทาสีมอยส์เจอร์ลงบนมาส์กให้น้อยลงด้วยผิวด้านน้ำหนักเบาไร้น้ำหนักและเคลือบด้าน ป้องกันคราบสกปรกแม้ในหน้ากากอนามัย"
    },

    {
        id: 20,
        name: "Fixing Bar - etude",
        price: 250.00,
        quantity: 8,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "MakeUp",
        brand: "etude",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/ed5.jpg",
        description : "อีทูดี้ ลิปสติกแท่ง ไม่เลอะติดแมสก์ Say No! To Dry and Stiff Matte!"
    },

    //Fwee
    {
        id: 21,
        name:  "Fwee Lip&Cheek Blurry Pudding Pot - Fwee",
        price: 560.00,
        quantity: 5,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "MakeUp",
        brand: "Fwee",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/f1.jpg",
        description : "โทนสีใหม่ที่ให้ความชุ่มชื้นด้วยพุดดิ้งและผงพร่ามัว เอฟเฟกต์รอยเปื้อนตามธรรมชาติราวกับว่าคุณกำลังระบายสีริมฝีปากและแก้ม"
    },

    {
        id: 22,
        name: "fwee fingerlike lip brush silicone / brush - Fwee",
        price: 739.00,
        quantity: 3,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "MakeUp",
        brand: "Fwee",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/f2.jpg",
        description : "แปลงซิลิโคนที่นุ่มเหมือนปลายนิ้ว ช่วยให้ทาสินค้าได้อย่างสะอาดไม่ต้องกังวลเรื่องทำความสะอาดแปรง"
    },

    {
        id: 23,
        name: "Fwee Glass Cushion Foundation - Fwee",
        price: 690.00,
        quantity: 4,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "MakeUp",
        brand: "Fwee",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/f3.jpg",
        description : "คุชชั่นเนื้อสัมผัสแบบ Semi-glow เพื่อผิวเปล่งปลั่งจากภายใน ให้ความธรรมชาติเปรียบเสมือนเหมือนเป็นผิวที่สอง ให้ความปกปิดเรียบเนียนพร้อมความติดทนยาวนาน"
    },

    {
        id: 24,
        name: "Fwee More Mood Eyeshadow Palette - Fwee",
        price: 1119.00,
        quantity: 6,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "MakeUp",
        brand: "Fwee",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/f4.jpg",
        description : "พาเลทตาที่มีสีสันหลากหลาย พร้อมกลิตเตอร์ที่มีเนื้อสัมผัสต่างกันถึง 5 สี พร้อมถ่ายทอดอารมณ์ของคุณในแต่ละวัน"
    },

    {
        id: 25,
        name: "Fwee 3D Voluming Gloss - Fwee",
        price: 959.00,
        quantity: 8,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "MakeUp",
        brand: "Fwee",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/f5.jpg",
        description : "ลิปกลอสแบบ 3 มิติที่ช่วยให้ริมฝีปากของคุณมีวอลลุ่มขึ้นทันทีที่ทาด้วย maxi-glaze"
    },

    //CeraVe
    {
        id: 26,
        name: "Hydrating Facial Cleanser - CeraVe",
        price: 560.00,
        quantity: 5,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "Skincare",
        brand: "CeraVe",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/cv1.jpg",
        description : " โฟมทำความสะอาดผิวหน้าและผิวกาย สำหรับผิวธรรมดา-ผิวมัน เป็นสิวง่าย ช่วยทำความสะอาดผิวได้อย่างสะอาดหมดจด พร้อมมีส่วนผสมของเซราไมด์และไนอะซินาไมด์ ช่วยปลอบประโลมผิวจากอาการระคายเคือง และไม่ทำให้ผิวแห้งตึงหลังทำความสะอาดผิว"
    },

    {
        id: 27,
        name: "Moisturising Cream - CeraVe",
        price: 739.00,
        quantity: 3,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "Skincare",
        brand: "CeraVe",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/cv2.jpg",
        description : "ครีมบำรุงผิวหน้าและผิวกาย ให้ความชุ่มชื้น สำหรับผิวแห้ง-แห้งมาก เนื้อเข้มข้น 50g.(มอยเจอร์ไรเซอร์ Moisturising Cream ผิวชุ่มชื้น)"
    },

    {
        id: 28,
        name: "PM Facial Moisturizing Lotion - CeraVe",
        price: 690.00,
        quantity: 4,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "Skincare",
        brand: "CeraVe",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/cv3.jpg",
        description : "โลชั่นบำรุงผิวหน้า #เพื่อนซี้กู้ภัยสิว ใช้สำหรับเช้า-เย็น ช่วยฟื้นบำรุงปราการปกป้องผิวแข็งแรง ให้ความชุ่มชื้นแก่ผิว สามารถใช้ควบคู่กับยารักษาสิวได้ "
    },

    {
        id: 29,
        name: "Skin Renewing Vitamin C Serum - CeraVe",
        price: 959.00,
        quantity: 6,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "Skincare",
        brand: "CeraVe",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/cv4.jpg",
        description : "รายละเอียดผลิตภัณฑ์ / PRODUCT DESCRIPTIONCeraVe Skin Renewing Vitamin C Serum เซรั่มที่มีวิตามินซีบริสุทธิ์เข้มข้น 10% (แอล-แอสคอร์บิก แอซิด) ใช้แล้วรู้สึกสบายผิวแม้ใช้ต่อเนื่อง 8 สัปดาห์** พร้อมเติมความชุ่มชื้นให้แก่ผิวด้วยอนุพันธ์ไฮยาลูโรนิก แอซิด และวิตามินบี 5 ด้วยเนื้อสัมผัสที่บางเบา ซึมไว ไม่เหนียวเหนอะหนะ"
    },

    {
        id: 30,
        name: "Ultra-Light Moisturizing Lotion SPF 30 - CeraVe",
        price: 959.00,
        quantity: 8,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "Skincare",
        brand: "CeraVe",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/cv5.jpg",
        description : "A lightweight moisturizer with SPF that’s non-comedogenic is an essential skincare product for normal to oily skin"
    },

    //Innisfree
    {
        id: 31,
        name: "Green Tea Seed Hyaluronic Serum - Innisfree",
        price: 660.00,
        quantity: 5,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "Skincare",
        brand: "Innisfree",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/in1.jpg",
        description : "ฟ้นฟูผิวแห้งทันที่ ด้วย Green Tea และ Hyaluronic Acid"
    },

    {
        id: 32,
        name: "Super Volcanic Pore Clay Mask - Innisfree",
        price: 529.00,
        quantity: 3,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "Skincare",
        brand: "Innisfree",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/in2.jpg",
        description : "ลดปัญหาความมันส่วนเกิน กระชับรูคุมขนด้วย clay mask"
    },

    {
        id: 33,
        name: "Innisfree Jeju orchid enriched cream - Innisfree",
        price: 1400.00,
        quantity: 4,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "Skincare",
        brand: "Innisfree",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/in3.jpg",
        description : "ปรับผิวกระจ่างใส พร้อมต้านริ้วรอย"
    },

    {
        id: 34,
        name: "Daily UV Defense Sunscreen - Innisfree",
        price: 594.00,
        quantity: 6,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "Skincare",
        brand: "Innisfree",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/in4.jpg",
        description : "กันแดด เนื้อสัมผัสอ่อนโยน พร้อมเอสเซนส์ให้ความชุ่มชื้นถึง 71%"
    },

    {
        id: 35,
        name: "Bija Salicylic Spot Serum - Innisfree",
        price: 959.00,
        quantity: 8,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "Skincare",
        brand: "Innisfree",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/in5.jpg",
        description : "A daily, non-stripping spot-gel serum with salicylic acid and Bija Seed Oil that helps clear dead skin cell build-up and impurities while addressing visible imperfections."
    },

    //Eucerin
    {
        id: 36,
        name: "Daily Protection Face Lotion Broad Spectrum SPF 30 - Eucerin",
        price: 1400.00,
        quantity: 5,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "Skincare",
        brand: "Eucerin",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/e1.jpg",
        description : "Zinc oxide and titanium dioxide which help defend against sunburn and long-term sun damage"
    },

    {
        id: 37,
        name: "Eucerin Eczema Relief Hydrogel - Eucerin",
        price: 739.00,
        quantity: 3,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "Skincare",
        brand: "Eucerin",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/e2.jpg",
        description : "Clinically proven to immediately soothe irritation from eczema"
    },

    {
        id: 38,
        name: "Eucerin® Face Immersive Hydration Daily Lotion Broad Spectrum SPF 30 - Eucerin",
        price: 849.00,
        quantity: 4,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "Skincare",
        brand: "Eucerine",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/e3.jpg",
        description : "Provides intense, smoothing hydration that lasts all day and reduces the look of fine lines and wrinkles"
    },

    {
        id: 39,
        name: "Eucerin Sun Advanced Hydration SPF 30 Sunscreen Lotion 5 Fl oz. - Eucerin",
        price: 990.00,
        quantity: 6,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "Skincare",
        brand: "Eucerin",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/e4.jpg",
        description : "Eucerin Advanced Repair Cream is a breakthrough in repairing very dry skin and provides 48 hour moisture, for skin that looks and feels healthy."
    },

    {
        id: 40,
        name: "Eczema Relief Cream & Body Wash - Eucerin",
        price: 1119.00,
        quantity: 8,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "Skincare",
        brand: "Eucerin",
        shop: "Beautrium",
        status: "New Product",
        image: "/images/e5.jpg",
        description : "Gentle Cleansing: Eucerin Baby Eczema Relief Cream & Body Wash is a gentle, non-foaming body wash that helps to calm dry, itchy skin associated with eczema"
    },

    //ClearNose
    {
        id: 41,
        name: "White Body Derma Serum - ClearNose",
        price: 589.00 ,
        quantity: 5,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "Skincare",
        brand: "ClearNose",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/cn1.jpg",
        description : "Help reduce dullness, uneven texture, and dark spots. Reveal a softer, smoother, and more even skin tone"
    },

    {
        id: 42,
        name: "Moist Skin Barrier Moisturizing Gel - ClearNose",
        price: 999.00,
        quantity: 3,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "Skincare",
        brand: "ClearNose",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/cn2.jpg",
        description : "Help reduce dryness and protect skin from pollution. Formulated for sensitive and acne-prone skin."
    },

    {
        id: 43,
        name: "Vitamin C Concentrate Super Serum - ClearNose",
        price: 1099.00,
        quantity: 4,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "Skincare",
        brand: "ClearNose",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/cn3.jpg",
        description : "that enhances one another to brighten dull skin, visibly reduce fine lines. It gently evens skin tone and texture. This lightweight Vitamin C Serum deeply nourishes skin to reduce the appearance of pores and reveal glowing skin clarity without dryness"
    },

    {
        id: 44,
        name: "Matte Serum Oil Free - ClearNose",
        price: 1100.00,
        quantity: 6,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "Skincare",
        brand: "ClearNose",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/cn4.jpg",
        description : "This Clear Nose serum is non-greasy, quickly absorbed while properly hydrating skin and calming down new oil production. With Cleome extract, 12 natural ingredients, peptide and Glyceryl glucoside. It will brighten your skin, diminish the pore appearance, and reveal smoother skin."
    },

    {
        id: 45,
        name: "UV Sun Serum SPF50+ PA++++ - ClearNose",
        price: 990.00,
        quantity: 8,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "Skincare",
        brand: "ClearNose",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/cn5.jpg",
        description : "A light touched, oil free, hybrid sunscreen that protects your skin from sunlight pollutions. SPF50+ PA++++ UVA1 UVA2 and UVB."
    },

    //Anua
    {
        id: 46,
        name: "HEARTLEAF 77% SOOTHING TONER, 250ml - Anua",
        price: 693.00,
        quantity: 5,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "Skincare",
        brand: "Anua",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/an1.jpg",
        description : "โทนเนอร์สุดฮอตจากโลกทวิตเตอร์ที่ใครลองก็หลงรัก จากอานัว ช่วยปลอบประโลมผิวและลดการอักเสบ ด้วยสารสกัดฮาร์ทลีฟถึง 77% เนื้อสัมผัสบางเบา ปราศจากน้ำหอมและสารเคมีอันตราย เหมาะกับทุกสภาพผิว โดยเฉพาะผิวระคายเคือง เป็นสิวและผดผื่น"
    },

    {
        id: 47,
        name: "Heartleaf Pore Control Cleansing Oil - Anua",
        price: 693.00,
        quantity: 5,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "Skincare",
        brand: "Anua",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/an2.jpg",
        description : "ผลิตภัณฑ์ทำความสะอาดสูตรอ่อนโยนอย่างล้ำลึก จากอานัว เนื้อสัมผัสที่บางเบาและให้ความรู้สึกสดชื่น จึงใช้งานได้ทุกวันอย่างสะดวกสบาย สามารถใช้ได้อย่างปลอดภัยแม้กับผิวที่เป็นสิวง่าย"
    },

    {
        id: 48,
        name: "Heartleaf 70% Intense Calming Cream - Anua",
        price: 825.00,
        quantity: 4,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "Skincare",
        brand: "Anua",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/an3.jpg",
        description : "A calming cream formulated with ceramide and panthenol, designed to strengthen and help maintain the skin’s moisture barrier."
    },

    {
        id: 49,
        name: "Peach 70% Niacinamide Serum - Anua",
        price: 825.00,
        quantity: 6,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "Skincare",
        brand: "Anua",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/an4.jpg",
        description : "Radiant Complexion, Provides Vitamin"
    },

    {
        id: 50,
        name: "BHA 2% Gentle Exfoliating Toner - Anua",
        price: 660.00,
        quantity: 8,
        date: "05-11-2567",
        update: "05-11-2567",
        category: "Skincare",
        brand: "Anua",
        shop: "Beautrium",
        status: "New Product",
        image : "/images/an5.jpg",
        description : "A gentle exfoliating toner formulated with 2% BHA, designed to exfoliate dead skin cells, help clogged pores, and improve skin clarity and balance."
    }
];
